import { Component, OnInit } from '@angular/core';
import { TimesheetConsumerListComponent } from '../timesheet-consumer-list/timesheet-consumer-list.component';
import { TimesheetProviderListComponent } from '../timesheet-provider-list/timesheet-provider-list.component';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-timesheet-detail',
  standalone: true,
  imports: [TimesheetConsumerListComponent, TimesheetProviderListComponent],
  templateUrl: './timesheet-detail.component.html',
  styleUrl: './timesheet-detail.component.css',
})
export class TimesheetDetailComponent implements OnInit {
  program: any;
  entry: any;
  isParticipantFlow = false;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry();
    this.isParticipantFlow = this.entry == 'participantEnrollment';
  }
}
